import { render, staticRenderFns } from "./char2audio_list.vue?vue&type=template&id=5b95e3f4"
import script from "./char2audio_list.vue?vue&type=script&lang=js"
export * from "./char2audio_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports